export default {
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },

  workShifts(state, workShifts) {
    return (state.workShifts = workShifts);
  },

  shiftTypes(state, shiftTypes) {
    return (state.shiftTypes = shiftTypes);
  },

  totalWorkShifts(state, total) {
    return (state.totalWorkShifts = total);
  },

  assignables(state, value) {
    return (state.assignables = value);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  branches(state, value) {
    return (state.branches = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  filterValue(state, value) {
    return (state.filterValue = value);
  },
  allRoster(state, allRoster) {
    return (state.allRoster = allRoster);
  },

  totalRoster(state, total) {
    return (state.totalRoster = total);
  },

  departments(state, value) {
    return (state.departments = value);
  },

  rosterParam(state, params) {
    return (state.rosterParam = params);
  },

  rosterDates(state, rosterDates) {
    return (state.rosterDates = rosterDates);
  },

  payload(state, value) {
    return (state.payload = value);
  },
};
